module.exports = __webpack_public_path__ + "img/elementheights_jasp.4c79c6bb.png";